import React from "react";
import { Phone } from "lucide-react";
import { COMPANY } from "../lib/constants";

export const StickyCallButton = () => {
  return (
    <a
      href={`tel:${COMPANY.phoneRaw}`}
      data-testid="sticky-call-button"
      className="lg:hidden fixed bottom-5 left-5 right-5 z-40 bg-white text-[#050914] flex items-center justify-center gap-3 py-4 text-sm uppercase tracking-[0.2em] font-semibold shadow-2xl shadow-black/50"
    >
      <Phone className="w-5 h-5" />
      Call Now · {COMPANY.phone}
    </a>
  );
};

export default StickyCallButton;
